import { MessageCirclePlusIcon, SendHorizonal } from 'lucide-react';
import { useState, useEffect, useRef } from 'react';
import IconTooltipWrapper from './IconTooltipWrapper';
import styles from './PromptInput.module.css';
import { useSelector } from 'react-redux';

const PromptInput = ({
  isChatActive,
  onStartNewChat,
  onSendPrompt,
  isLoading,
  isLoadingAndStreaming,
}) => {
  const [prompt, setPrompt] = useState('');
  const selectedChat = useSelector(state => state.aiReducer.selectedChat);
  const aiSidebarMode = useSelector(state => state.aiReducer.aiSidebarMode);
  const [shouldAutofocus, setShouldAutofocus] = useState(false);

  const textareaRef = useRef(null);

  const trimmedPrompt = prompt.trim();

  const handleSubmit = async e => {
    e.preventDefault();
    onSendPrompt(prompt.trim());
    setPrompt('');
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  useEffect(() => {
    if (!shouldAutofocus) {
      setShouldAutofocus(true);
      return;
    }

    const sidebarIsOpen = aiSidebarMode !== 'closed';
    if (sidebarIsOpen && isChatActive && !selectedChat && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [aiSidebarMode, isChatActive, selectedChat, shouldAutofocus]);

  const DEFAULT_ROW_HEIGHT = 5;
  const PLACEHOLDER_TEXT = 'Ask a single question...';
  return (
    <>
      {!selectedChat && isChatActive ? (
        <form onSubmit={handleSubmit} className={styles.promptInputWrapper}>
          <textarea
            className={styles.textarea}
            ref={textareaRef}
            value={prompt}
            readOnly={isLoadingAndStreaming}
            onChange={e => setPrompt(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={PLACEHOLDER_TEXT}
            rows={DEFAULT_ROW_HEIGHT}
          />
          <button
            type='submit'
            className={styles.submitButton}
            disabled={!trimmedPrompt || isLoading}>
            <SendHorizonal size={18} aria-label='Send message' />
          </button>
        </form>
      ) : (
        <div className={styles.newChatPromptDiv}>
          <IconTooltipWrapper label='Ask a new question'>
            <button
              className={styles.newChatButton}
              onClick={() => {
                onStartNewChat();
              }}
              aria-label='Start a new chat'>
              <MessageCirclePlusIcon size='50%' />
            </button>
          </IconTooltipWrapper>
        </div>
      )}
    </>
  );
};

export default PromptInput;
